import { Request } from "@xt/xtbase";
const { XtAxios } = Request;

const URL = "/xt-lever/";

//获取杠杆市场配置
export function get_marketConfig(config?) {
  return XtAxios.get(URL + `marketConfig`, config);
}

//获取杠杆账户预览
export function get_accountOverview(marketName, config?) {
  return XtAxios.get(URL + `account/${marketName}/overview`, config);
}

//获取订阅杠杆 ws 的 userKey token
export function get_tokenUserKey(config?) {
  return XtAxios.get(URL + `token/userKey`, config);
}

//借款
export function post_loan({ market, coin, amount, trace }, config) {
  return XtAxios.post(URL + `loan/${market}/${coin}?amount=${amount}&trace=${trace}`, null, config);
}
//还款
export function post_repayLoan({ market, coin, amount, trace }, config) {
  return XtAxios.post(URL + `repayLoan/${market}/${coin}?amount=${amount}&trace=${trace}`, null, config);
}